<template>
  <v-dialog
    v-if="form != null"
    v-model="showOpenJob"
    max-width="1200px"
    persistent
  >
    <v-card>
      <v-card-title
        style="position: sticky; top: 0px; background-color: white; z-index: 10"
        class="headline indigo--text"
      >
        {{ form.act == 'update' ? 'Edit' : 'Tambah' }} Lowongan
        <v-btn
          text
          small
          fab
          icon
          @click="closeJobDialog"
          style="position: absolute; top: 10px; right: 10px"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form :disabled="form.act == 'update'" @submit.prevent="addJob">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.name"
                @keydown.enter.prevent
                label="Posisi *"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                label="Jenis Pekerjaan"
                @keydown.enter.prevent
                v-model="form.employement_type"
                :items="dropdown.employee_type"
                item-text="name"
                item-value="id"
                return-id
                dense
                clearable
                required
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                @keydown.enter.prevent
                label="Jabatan"
                v-model="form.position"
                :items="dropdown.position"
                item-text="name"
                item-value="id"
                return-object
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                @keydown.enter.prevent
                label="Perusahaan *"
                v-model="form.company"
                :items="dropdown.company"
                item-text="name"
                item-value="id"
                return-object
                dense
                clearable
                @change="companyWatcher"
              ></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                @keydown.enter.prevent
                label="Department"
                v-model="form.department"
                :items="dropdown.department"
                :disabled="form.act == 'update' || form.company == null"
                item-text="name"
                item-value="id"
                return-object
                dense
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-text-field
                @keydown.enter.prevent
                v-model="form.location"
                label="Lokasi Penempatan *"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                @keydown.enter.prevent
                label="Batas Pendaftaran"
                v-model="form.deadline"
                clearable
                dense
                type="date"
                name="date"
                step="1"
                :disabled="false"
              />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                @keydown.enter.prevent
                label="Status"
                v-model="form.status"
                :items="dropdown.status"
                item-text="name"
                item-value="id"
                return-id
                dense
                :disabled="false"
              ></v-autocomplete>
            </v-col>
            <!-- <v-col cols="12">
                  <p style="margin: 0; font-size: 14px">Keterangan Tambahan</p>
                  <vue-editor
                    class="textEditor"
                    style="min-height: 100px"
                    v-model="form.requirements"
                    clearable
                  ></vue-editor>
                </v-col> -->
          </v-row>
          <!-- <v-textarea
                label="Requirement"
                dense
                auto-grow
                rows="3"
                v-model="form.requirements"
              />
              <v-textarea
                label="Keterangan Lain-lain"
                dense
                auto-grow
                rows="3"
                v-model="form.description"
              /> -->
          <v-card-actions>
            <v-btn
              style="width: 100%; margin-top: 30px"
              type="submit"
              color="primary"
              >Simpan</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['form', 'dropdown', 'showOpenJob'],
  data() {
    return {}
  },
  methods: {
    closeJobDialog() {
      this.$emit('closeJobDialog')
    },
    companyWatcher(v) {
      this.$emit('companyWatcher', v)
    },
    addJob() {
      this.$emit('addJob')
    }
  }
}
</script>

<style lang="scss" scoped>
#masterjob {
  position: relative;
  .masterjob-list {
    margin: 10px 20px;
    min-height: 20vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .recruit-toolbar-1 {
      margin-left: auto;
    }
  }
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 9999;
}

.loading-spinner {
  border: 16px solid rgba(255, 255, 255, 0.2);
  border-top: 16px solid #2e2be2;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 1s linear infinite;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.gantistatus {
  margin-top: 20px;
  width: 100%;
}
</style>
